/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["text-preview{display:block;background-color:#fff;box-shadow:0 3px 3px -2px rgba(0,0,0,.2),0 3px 4px 0 rgba(0,0,0,.14),0 1px 8px 0 rgba(0,0,0,.12);width:80%;min-height:80%;color:rgba(0,0,0,.87);word-wrap:break-word;padding:20px;overflow:auto}@media only screen and (max-width:768px){text-preview{width:90%}}text-preview pre{display:block;white-space:pre-wrap;word-wrap:break-word;margin:0;font-size:1.4rem;font-family:inherit}"];
export { styles as styles };
